import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "../../Breadcrumb";
// Product images
import HerbalSingleProduct from "./Herbal";
import { useEffect } from "react";
export default function HerbalProduct() {
  useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
          @media (max-width: 998px) {
            .custom-mobile-margin {
              margin-top: 10% !important;
            }
          }
            @media (max-width: 750px) {
            .custom-mobile-margin {
              margin-top: 13% !important;
            }
          }
            
        `;
        document.head.appendChild(style);
      
        return () => {
          document.head.removeChild(style);
        };
      }, []);
  return (
    <div className="productPage">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 custom-mobile-margin">
            <div className="row">
              <Breadcrumbs currentPathName="Iron and cast iron " />
              <div className="col-md-6">
                <ul className="list-inline shop-top-menu pb-3 pt-1">
                  <li className="list-inline-item">
                    <Link
                      className="h3 text-dark text-decoration-none mr-3 text-uppercase"
                      to="/herbalProduct"
                    >
                      Iron and cast iron
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <HerbalSingleProduct />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
